import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { BlogCard } from '@/model/blog';
import { openWebView } from '@/utils/scheme';

const firebaseModule = namespace('firebase');
const blogModule = namespace('blog');

const BLOG_ITEMS = 'blog_items';

export enum WebStorage {
  session = 'session',
  local = 'local'
}

@Component
export default class BlogMixin extends Vue {
  @firebaseModule.State
  database: any;

  @firebaseModule.State
  storage: any;

  @blogModule.Getter('items')
  blogItems!: BlogCard[];

  @blogModule.Getter
  isLoading!: boolean;

  @blogModule.Action
  setBlogItems!: (blogItems: BlogCard[]) => void;

  @blogModule.Action
  setIsLoading!: (status: boolean) => void;

  goBlog(url: string) {
    openWebView(url);
  }

  loadFromWebStorage(location?: WebStorage): BlogCard[] | null {
    switch (location) {
      case WebStorage.local:
        return JSON.parse(window.localStorage.getItem(BLOG_ITEMS) ?? 'null');
      case WebStorage.session:
      default:
        return JSON.parse(window.sessionStorage.getItem(BLOG_ITEMS) ?? 'null');
    }
  }

  cacheToWebStorage(items: BlogCard[], location?: WebStorage) {
    window.sessionStorage.setItem(BLOG_ITEMS, JSON.stringify(items));
    switch (location) {
      case WebStorage.local:
        window.localStorage.setItem(BLOG_ITEMS, JSON.stringify(items));
        break;
      case WebStorage.session:
      default:
        window.sessionStorage.setItem(BLOG_ITEMS, JSON.stringify(items));
        break;
    }
  }

  clearWebStorage(location?: WebStorage) {
    switch (location) {
      case WebStorage.local:
        window.localStorage.removeItem(BLOG_ITEMS);
        break;
      case WebStorage.session:
      default:
        window.sessionStorage.removeItem(BLOG_ITEMS);
        break;
    }
  }

  async fetchBlogItems(count?: number): Promise<BlogCard[]> {
    const imagesRef = await this.storage.ref('blogImages');
    const items: BlogCard[] = [];
    let querySnapshot = null;

    if (count) {
      querySnapshot = await this.database
        .collection('blogItems')
        .orderBy('date', 'desc')
        .limit(count)
        .get();
    } else {
      querySnapshot = await this.database
        .collection('blogItems')
        .orderBy('date', 'desc')
        .get();
    }

    for (const doc of (querySnapshot as any).docs) {
      const data = doc.data();
      const imageUrl = await imagesRef
        .child(data.imageName)
        .getDownloadURL()
        .then((url: string) => url);
      items.push({
        id: doc.id,
        title: data.title,
        imageUrl: imageUrl,
        date: data.date,
        link: data.link
      });
    }
    return items;
  }
}
